/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
 ==========================================================================================*/

export default {
  SET_PORTAL_TYPE(state, type) {
    state.type = type
  },
  SET_PORTAL_PERMISSION(state, data) {
    state.permissions = data
  },
  RESET_PORTAL(state) {
      state.id = '',
      state.username = '',
      state.password = '',
      state.device_id = '',
      state.type = '',
      state.venue_id = -1,
      state.role = '',
      state.duration = 15,
      state.config = {
        destination: "",
        name: "",
        request_as: ""
      },
      state.customer_id = ""
      state.permissions = "",
      state.capabilities = "",
      state.registration_key = null
  },
  UPDATE_PORTAL(state, data) {
    // console.log(data);
      state.id = data.id ? data.id : '',
      state.username = data.username ? data.username : '',
      state.password = data.password ? data.password : '',
      state.device_id = data.device_id? data.device_id : '',
      state.type = data.type ? data.type : '',
      state.venue_id = data.venue_id ? data.venue_id : '',
      state.role = data.role ? data.role : '',
      state.duration = data.duration ? data.duration : '',
      state.config = data.config ? data.config : '',
      state.customer_id = data.customer_id ? data.customer_id : '',
      state.capabilities = data.capabilities ? data.capabilities : '',
      state.registration_key = (data.registration_key !== undefined && data.registration_key !== null) ? data.registration_key : null


  }



}

